import React from 'react';
import Modal from '../../components/Modal';
import { Device, deviceLabel } from '../../api/device';
import { useDictText } from '../../components/DictSelect';
import DeviceSchemaGroups from './DeviceSchemaGroups';

// 设备动态字段值编辑弹窗: 内容与 设备工况 Profile 页共用 DeviceSchemaGroups 面板.
// 字段组定义在「Schema 管理 → 模板 → 设备」维护; 这里只按组填值, 整组保存 (空 = 不设置).

function DeviceExtValueModal({ device, onClose }: { device: Device; onClose: () => void }) {
    // 设备展示名的光源段走字典 label (light_source), 不裸显 code
    const lightText = useDictText('light_source');
    return (
        <Modal
            open
            title={`设备动态字段 · ${deviceLabel(device, lightText)}`}
            subtitle="字段组在「Schema 管理 → 模板 → 设备」定义; 按组填值, 整组保存 (空 = 不设置)"
            onClose={onClose}
            width={760}
        >
            <div className="max-h-[62vh] overflow-auto pr-1">
                <DeviceSchemaGroups deviceKey={device.deviceKey} archCode={device.archCode} />
            </div>
        </Modal>
    );
}

export default DeviceExtValueModal;
